<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/configuration/integrations']">Integraciones</a></li>
</ul>

<p-card>
  <ng-template pTemplate="header">
    <div class="p-card-title">
      Integraciones
    </div>
  </ng-template>
  <div class="p-grid">
    <!--<div class="p-col-12 p-field">
      <div class="p-inputgroup">
        <input [(ngModel)]="search" id="search" name="search" type="text" pInputText placeholder="Texto a buscar" autocomplete="false" />
      </div>
    </div>-->
    <p-panel class="p-col-4" showHeader="false" *ngFor="let item of integrations">
      <div class="p-grid p-jc-center">
        <img src="/assets/img/integrations/{{item.code}}.png" style="max-height: 60px; max-width: 100%;" />
        <div class="p-mt-4 p-text-center">
          <b>{{item.name}}</b><br />
          {{item.description}}
        </div>
        <div class="p-mt-4">
          <button pButton icon="pi pi-cog" label="Configurar" (click)="open(item.code)"></button>
        </div>
      </div>
    </p-panel>
  </div>
</p-card>


